import { computed, Injectable, Signal, signal } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export abstract class BaseConsentService {
  protected _isPerformanceAllowed = signal(false);
  protected _isTargetingAllowed = signal(false);

  public readonly performanceAllowed: Signal<boolean> = computed(() => this._isPerformanceAllowed());
  public readonly targetingAllowed: Signal<boolean> = computed(() => this._isTargetingAllowed());
}
